import {
    TextField,
    Select,
    FormControl
} from '@mui/material';
import { TextareaAutosize } from '@mui/material';
import { styled } from "@mui/system";


export const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-input': {
        fontSize: '14px',  // Set font size for input text
    },
    '& .MuiInputBase-root' : {
        backgroundColor: 'transparent'
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px', 
        marginBottom: '1em',
        color: theme.palette.color,
        backgroundColor: 'transparent',
        '& fieldset': {
            borderColor: theme.palette.contentCopy, 
        },
        '&:hover fieldset': {
            borderColor: theme.palette.contentCopy, 
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.contentCopy, 
        },
    },
    '& .MuiInputLabel-root': {
        position: 'absolute', 
        top: '3px', 
        left: '0px', 
        fontSize: '10px', 
        color: theme.palette.contentCopy,
    },
    '&.Mui-focused fieldset': {
        color: theme.palette.contentCopy, 
    },
    '& .MuiInputLabel-shrink': {
        top: '4px', 
    },
}));


export const CustomSelect = styled(Select)(({ theme }) => ({
    backgroundColor: 'transparent',
    borderRadius: '8px',
    fontSize: '14px',
    width: '16vw',
    margin: '20px',
    '& .MuiInputBase-input': {
        fontSize: '14px',  // Set font size for input text
        color: theme.palette.color
    },
    '& .MuiInputBase-root' : {
        backgroundColor: 'transparent',
        color: theme.palette.color
    },
    '& .MuiOutlinedInput-notchedOutline': {
        backgroundColor: 'transparent',
        borderRadius: '8px',
        borderColor: theme.palette.contentCopy,
    },
    '& .MuiInputLabel-root': {
        position: 'absolute', 
        top: '3px', 
        left: '0px', 
        fontSize: '10px', 
        // color: theme.palette.contentCopy,
        color: `${theme.palette.contentCopy} !important`,
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: theme.palette.contentCopy, 
    },
    '& .MuiInputLabel-shrink': {
        top: '4px', 
    },
    

  }));


export const CustomFormControl = styled(FormControl)(({ theme }) => ({
    backgroundColor: 'transparent',
    borderRadius: '8px',
    fontSize: '14px',
    // width: '16vw',
    height: '40px',  
    color: theme.palette.color,
    
    '& .MuiInputLabel-root': {
      position: 'absolute',
      top: '3px',
      left: '0px',
      fontSize: '10px',
      color: theme.palette.contentCopy,
      
    },
  
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: 'transparent',
      border: '1px solid',
      height: '100%',  // Ensure it takes the height of the FormControl
  
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.contentCopy,
      },
  
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.contentCopy,
      },
  
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.contentCopy,
      },
  
      '& .MuiSelect-select': {
        padding: '4px 10px',  
        fontSize: '14px',
        color: theme.palette.text.primary,
        height: '100%',  
        display: 'flex',
        alignItems: 'center',
      },
    },

    '& .MuiInputBase-input': {
        color: theme.palette.color,  
      },

    '& .MuiInputLabel-root.Mui-focused': {
        backgroundColor: 'black',  
        padding: '0 6px',  
    },

    '& .MuiSelect-select': {
        color: theme.palette.color,
      },

    '& .MuiSelect-icon': {
      color: theme.palette.color,
    },
    '& .MuiSelect-select.MuiSelect-multiple': {
      color: theme.palette.color,  
    },
  }));

  export const CustomTextareaAutosize = styled(TextareaAutosize)(({ theme }) => ({
    backgroundColor: 'transparent',
    borderRadius: '8px',
    fontSize: '14px',
    // width: '16vw',
    height: '40px',  
    color: theme.palette.color,
    
    '& .MuiInputLabel-root': {
      position: 'absolute',
      top: '3px',
      left: '0px',
      fontSize: '10px',
      color: theme.palette.contentCopy,
      
    },
  
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: 'transparent',
      border: '1px solid',
      height: '100%',  // Ensure it takes the height of the FormControl
  
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.contentCopy,
      },
  
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.contentCopy,
      },
  
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.contentCopy,
      },
  
      '& .MuiSelect-select': {
        padding: '4px 10px',  
        fontSize: '14px',
        color: theme.palette.text.primary,
        height: '100%',  
        display: 'flex',
        alignItems: 'center',
      },
    },

    '& .MuiInputBase-input': {
        color: theme.palette.color,  
      },

    '& .MuiInputLabel-root.Mui-focused': {
        backgroundColor: 'black',  
        padding: '0 6px',  
    },

    '& .MuiSelect-select': {
        color: theme.palette.color,
      },

    '& .MuiSelect-icon': {
      color: theme.palette.color,
    },
    '& .MuiSelect-select.MuiSelect-multiple': {
      color: theme.palette.color,  
    },
  }));


